import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table/interface';
import type { ReactNode } from 'react';
import { ReportSection } from './ReportSection';
import styles from '../Reports.module.scss';

interface ReportTableProps<T extends object> {
  sectionKey: string;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  preview?: string;
  defaultExpanded?: boolean;
  rowKey: string | ((record: T) => string);
  columns: ColumnsType<T>;
  dataSource?: T[];
  extra?: ReactNode;
}

export function ReportTable<T extends object>({
  sectionKey,
  title,
  subtitle,
  icon,
  preview,
  defaultExpanded = true,
  rowKey,
  columns,
  dataSource = [],
  extra,
}: ReportTableProps<T>) {
  const rows = dataSource ?? [];
  const countPreview = preview ?? (rows.length > 0 ? `${rows.length} rows` : undefined);

  return (
    <ReportSection
      sectionKey={sectionKey}
      title={title}
      subtitle={subtitle}
      icon={icon}
      preview={countPreview}
      defaultActive={defaultExpanded}
    >
      {extra}
      <div className={styles.tableCard}>
        <Table<T>
          className={styles.reportTable}
          rowKey={rowKey}
          columns={columns}
          dataSource={rows}
          pagination={false}
          scroll={{ x: 'max-content' }}
          size="small"
        />
      </div>
    </ReportSection>
  );
}
